export default {
  version: import.meta.env.VITE_VERSION
}
